const API_URL = process.env.VUE_APP_URL;

const getCPTList = async (orgId) => {
    try {
        const response = await window.axios.get(`${API_URL}/cpt?orgId=${orgId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getCPTRelationsList = async (orgId) => {
    try {
        const response = await window.axios.get(`${API_URL}/cpt/relations?orgId=${orgId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getCPTAdminList = async () => {
    try {
        const response = await window.axios.get(API_URL + '/cpt/admin');
        return response;
    } catch (error) {
        throw error;
    }
};

export default {
    getCPTList,
    getCPTRelationsList,
    getCPTAdminList
};
